import SchoolDesignPreview from './components/SchoolDesignPreview.vue'
import { store } from './stores'

export default {
  elementId: 'school-design-preview',
  rootComponent: SchoolDesignPreview,
  stores: [
    {
      key: ['SchoolDesignPreview'],
      module: store
    }
  ]
}
